<template>
  <div class="container">
    <div class="searchBox">
      <van-search
        v-model="keyword"
        shape="round"
        background="transparent"
        placeholder="搜索"
        @search="searchHandle"
      />
    </div>
    <van-swipe
      class="swipeBox"
      :duration="duration"
      :autoplay="autoplay"
      indicator-color="#333"
    >
      <van-swipe-item
        class="swipeItem"
        v-for="(item, index) in bannerList"
        :key="index"
      >
        <van-image
          fit="cover"
          :src="item.Img"
          @click.stop="toDetailHandle(item.Path)"
        />
      </van-swipe-item>
    </van-swipe>

    <!-- 企业直播 -->
    <div
      class="liveBox"
      v-if="duringLiveList != null && duringLiveList.length > 0"
    >
      <router-link class="topBox" to="/liveOnline">
        <div class="title">企业直播</div>
        <div class="more" v-if="showMore">
          <span>更多</span><span class="iconfont icon-right"></span>
        </div>
      </router-link>
      <div class="scroll-wrap">
        <div
          class="li_item"
          v-for="(item, index) in duringLiveList"
          :key="index"
        >
          <mini-program
            :path="
              '/subpackagelive/pages/liveDetail/liveDetail?id=' + item.LiveId
            "
          >
            <div class="li_top">
              <div class="lit_state">
                <div class="lits_text red">
                  <img
                    src="../../../static/images/index/status.gif"
                    v-if="item.Status == 0"
                  />
                  <span>直播</span>
                </div>
              </div>
              <van-image fit="cover" :src="item.Cover" class="coverImg" />
            </div>
            <div class="li_btm overFlowTwo">{{ item.Title }}</div>
          </mini-program>
        </div>
      </div>
    </div>

    <!-- 直播预告 -->
    <div
      class="liveBox"
      v-if="beforeLiveList != null && beforeLiveList.length > 0"
    >
      <router-link class="topBox" to="/livePreview">
        <div class="title">直播预告</div>
        <div class="more" v-if="showMore">
          <span>更多</span><span class="iconfont icon-right"></span>
        </div>
      </router-link>
      <div class="scroll-wrap">
        <div
          class="li_item"
          v-for="(item, index) in beforeLiveList"
          :key="index"
        >
          <mini-program
            class="actItem"
            :path="
              '/subpackagelive/pages/liveDetail/liveDetail?id=' + item.LiveId
            "
          >
            <div class="li_top">
              <div class="lit_state">
                <div class="lits_text orange">
                  <span>预告</span>
                </div>
                <div class="lits_time">{{ item.StartTimeDesc }}</div>
              </div>
              <van-image fit="cover" :src="item.Cover" class="coverImg" />
            </div>
            <div class="li_btm overFlowTwo">{{ item.Title }}</div>
          </mini-program>
        </div>
      </div>
    </div>

    <!-- 推荐活动 -->
    <div class="actBox">
      <div class="topBox">
        <div class="title">推荐活动</div>
        <router-link class="actBtn" to="/specialCalendar">
          <img src="../../../static/images/index/icon_time.png" />
          <span>活动日历</span>
        </router-link>
      </div>
      <div
        class=""
        v-if="oneInfo != null"
        @click="toActivity(oneInfo.SEID, oneInfo.SETitle)"
      >
        <van-image
          fit="cover"
          src="https://files.alighting.com/Cover/allYear.png"
          class="posterImg"
        />
        <div class="actName overFlowTwo">阿拉丁网上照明展览会-展商报名通道</div>
      </div>
      <!-- 推荐活动数位双数 -->
      <!-- v-if="actTotal % 2 == 0" -->
      <div class="actListBox">
        <div
          class="actItem"
          v-for="(item, index) in actList"
          :key="index"
          @click.stop="toSpecialDetail(item.SpecialId)"
        >
          <van-image fit="cover" :src="item.Cover" />
          <div class="actName overFlowTwo">{{ item.Name }}</div>
        </div>
      </div>

      <!-- 推荐活动数位单数 -->
      <!-- <div v-else>
        <div @click.stop="toSpecialDetail(actList[0].SpecialId)">
          <van-image fit="cover" :src="actList[0].Cover" class="posterImg" />
          <div class="actTitle overFlowTwo">{{ actList[0].Name }}</div>
        </div>
        <div class="actListBox">
          <div
            class="actItem"
            v-for="(item, index) in jactList"
            :key="index"
            @click.stop="toSpecialDetail(item.SpecialId)"
          >
            <van-image fit="cover" :src="item.Cover" />
            <div class="actName overFlowTwo">{{ item.Name }}</div>
          </div>
        </div>
      </div> -->

      <router-link class="seeMore" to="/specificAct">
        <span>查看更多</span><span class="iconfont icon-right"></span
      ></router-link>
    </div>

    <!-- 精彩回顾 -->
    <div class="backBox">
      <div class="title">精彩回顾</div>
      <van-list
        class="actListBox"
        v-model="loading"
        :finished="finished"
        :error.sync="error"
        error-text="请求失败，点击重新加载"
        @load="getMobileLiveList(2)"
      >
        <div
          class="actItem"
          v-for="(item, index) in afterLiveList"
          :key="index"
        >
          <mini-program
            class="actItem"
            :path="
              '/subpackagelive/pages/liveDetail/liveDetail?id=' + item.LiveId
            "
          >
            <div class="li_top">
              <div class="lit_state">
                <div class="lits_text purple">
                  <span>回放</span>
                </div>
              </div>
              <van-image fit="cover" :src="item.Cover" class="coverImg" />
            </div>
            <div class="actName overFlowTwo">{{ item.Title }}</div>
          </mini-program>
        </div>
      </van-list>
    </div>

    <!-- 抽奖按钮 -->
    <mini-program
      class="prizeBox"
      path="subpackagelive/pages/luckDraw/luckDraw"
    >
      <img src="../../../static/images/index/fw_icon.png" />
    </mini-program>
  </div>
</template>
<script>
import miniProgram from "@/components/miniProgram";
import { Search, Swipe, SwipeItem, Image, List } from "vant";
import {
  swipeList,
  mobileLiveList,
  liveSpecialList,
  getNewSE,
} from "@/api/online";
export default {
  name: "onlineExhibition",
  components: {
    miniProgram,
    "van-search": Search,
    "van-swipe": Swipe,
    "van-swipe-item": SwipeItem,
    "van-image": Image,
    "van-list": List,
  },
  data() {
    return {
      keyword: "",
      autoplay: 2000,
      duration: 500,
      bannerList: [],

      beforeLiveList: [], //预告
      duringLiveList: [], //直播中
      showMore: false,

      afterLiveList: [], //回放
      pageIndex: 1,
      total: 0,
      error: false,
      loading: false,
      finished: false,

      actList: [], //专题
      jactList: [], //单数时专题
      actTotal: 0, //判断奇偶

      oneInfo: "", //最近一期主题展
    };
  },
  methods: {
    //跳转专题
    toDetailHandle(path) {
      if (path.indexOf("?") != -1) {
        var str = path.substr(1);
        var sid = str.split("=")[1];
        this.$router.push({
          path: "/specificActDetail",
          query: { sid: sid },
        });
      }
    },

    //跳转搜索页
    searchHandle() {
      this.$router.push({
        path: "/liveSearch",
        query: { keyword: this.keyword },
      });
    },

    //跳转专题详情
    toSpecialDetail(id) {
      this.$router.push({ path: "/specificActDetail", query: { sid: id } });
    },

    //跳转主题展
    toActivity(id, title) {
      this.$router.push({ path: "/activity", query: { id: id } });
    },

    //获取轮播图
    getBannerList() {
      var that = this;
      var data = {
        Type: 295,
        Keyword: "",
        PageModel: {
          PageSize: 4,
          PageIndex: 1,
        },
      };
      swipeList(data).then((res) => {
        that.bannerList = res.Data.List;
        let arr = [0, 1];
        for (let i = 0; i < arr.length; i++) {
          that.getMobileLiveList(arr[i]);
        }
      });
    },

    //获取直播列表
    getMobileLiveList(status) {
      var that = this;
      var pageSize;
      if (status == 2) {
        pageSize = 10;
      } else {
        pageSize = 5;
      }
      var data = {
        CategoryId: 0,
        MemberId: 0,
        Keyword: "",
        Page: {
          PageSize: pageSize,
          PageIndex: that.pageIndex,
        },
        Recommend: -1,
        SpecialId: -1,
        HasQrcode: 1,
        Status: status,
      };
      mobileLiveList(data)
        .then((res) => {
          if (status == 0) {
            that.duringLiveList = res.Data.List;
            if (res.Data.Total > 6) {
              this.showMore = true;
            }
          } else if (status == 1) {
            var list = res.Data.List;
            list.forEach((item, index) => {
              item.StartTimeDesc = item.StartTimeDesc.substr(5).replace(
                /-/g,
                "/"
              );
            });
            that.beforeLiveList = list;
            if (res.Data.Total > 6) {
              this.showMore = true;
            }
          } else if (status == 2) {
            if (that.pageIndex == 1) {
              that.afterLiveList = [...res.Data.List];
            } else {
              that.afterLiveList = [...that.afterLiveList, ...res.Data.List];
            }
            that.total = res.Data.Total;
            that.pageIndex += 1;
            // 加载状态结束
            that.loading = false;
            // 数据全部加载完成
            if (that.afterLiveList.length >= that.total) {
              that.finished = true;
            }
          } else {
          }
        })
        .catch((err) => {
          that.loading = false;
          that.error = true;
          that.Common.showMsg(err);
        });
    },

    //获取最近一期主题展
    getOneEx() {
      getNewSE().then((res) => {
        this.oneInfo = res.Data;
      });
    },

    //获取专题
    getSpecialList() {
      var that = this;
      var data = {
        Page: {
          PageSize: 6,
          PageIndex: 1,
        },
        IsRec: 1,
        Keyword: "",
      };
      liveSpecialList(data).then((res) => {
        that.actList = res.Data.List;
        that.jactList = res.Data.List.slice(1);
        that.actTotal = res.Data.Total;
      });
    },
  },

  mounted() {
    this.getBannerList();
    this.getSpecialList();
    this.getOneEx();
  },
};
</script>
<style lang="less" scoped>
.container {
  min-height: 100vh;
  background-color: #efefef;
  .swipeBox {
    width: 100%;
    height: 282px;
    .van-image {
      width: 100%;
      height: 100%;
    }
  }
  .liveBox {
    background-color: #fff;
    padding: 15px 0px 30px 8px;
    margin-bottom: 12px;

    .more {
      font-size: 12px;
      color: #999;
      display: flex;
      align-items: center;
      .iconfont {
        font-size: 11px;
        margin-left: 5px;
      }
    }
    .scroll-wrap {
      min-width: 100%;
      white-space: nowrap;
      overflow-x: auto;
      overflow-y: hidden;
      .li_item {
        width: 170px;
        margin-right: 8px;
        display: inline-block;
        vertical-align: top;

        .li_btm {
          width: 160px;
          color: #333333;
          font-size: 14px;
          padding-top: 10px;
          white-space: pre-wrap;
        }
      }
    }
  }
  .actBox {
    background-color: #fff;
    padding: 15px 7px 20px 7px;
    margin-bottom: 12px;
    .actBtn {
      width: 95px;
      height: 30px;
      line-height: 30px;
      border: 1px solid #cccccc;
      border-radius: 15px;
      color: #d62f2f;
      font-size: 12px;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 14px;
        height: 14px;
        margin-right: 5px;
      }
    }

    .seeMore {
      font-size: 12px;
      color: #999;
      display: flex;
      align-items: center;
      justify-content: center;
      .iconfont {
        font-size: 11px;
        margin-left: 5px;
      }
    }
  }
  .prizeBox {
    position: fixed;
    right: 10px;
    bottom: 20px;
    z-index: 1;
    img {
      width: 70px;
      height: 70px;
    }
  }
}

.posterImg {
  width: 360px;
  height: 220px;
  display: block;
  margin: 0 auto;
}
.actListBox {
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;

  .actItem {
    width: 175px;
    margin-right: 9px;
    margin-bottom: 10px;

    &:nth-child(2n) {
      margin-right: 0px;
    }
    .van-image {
      width: 100%;
      height: 98px;
      display: block;
    }
  }
}
.actName {
  font-size: 14px;
  color: #333;
  margin: 10px 0px;
}

.backBox {
  background-color: #fff;
  padding: 15px 8px 33px 8px;
}
.topBox {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0px 11px 17px 2px;
}
.title {
  font-size: 18px;
  font-weight: bold;
  color: #000;
}

.actTitle {
  margin-top: 9px;
  font-size: 14px;
  color: #333;
  margin-bottom: 20px;
}
.li_top {
  width: 100%;
  height: 98px;
  position: relative;
  .lit_state {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    font-size: 10px;
    color: #ffffff;
    .lits_text {
      display: flex;
      align-items: center;
      height: 18px;
      padding: 0 5px;
      img {
        width: 15px;
        height: 15px;
        margin-right: 2px;
      }
    }
    .red {
      background-color: #ff3535;
    }

    .purple {
      background-color: #a421a6;
    }

    .orange {
      background-color: #ff8400;
    }
    .lits_time {
      padding: 0 5px;
      line-height: 18px;
      background-color: rgba(255, 132, 0, 0.6);
    }
  }
  .coverImg {
    width: 100%;
    height: 100%;
    display: block;
  }
}
</style>
